// @ts-strict-ignore
import { useLocation } from 'react-router';

import { PublicPage, Subsite } from 'api/website';

type Props = {
  content: PublicPage | undefined;
};

type ContentSubsiteLocationState = {
  subsite: Subsite;
};

export function useContentSubsite({ content }: Props): Subsite | undefined {
  const location = useLocation();
  const state = location.state as ContentSubsiteLocationState;

  return state && state.subsite
    ? {
        ...state.subsite,
        defaultSearchType: content.subsite.defaultSearchType,
      }
    : content && content.subsite;
}
